import React from 'react'
import { connect } from 'react-redux'
import Sidebar from 'containers/sidebar'
import Button from 'components/controls/button'
import Storage from 'shared/helpers/storage'
import { timezone, isPMOrAdmin, isQSAdmin } from 'shared/helpers/user'
import ChangeTimeZoneModal from 'containers/dashboard/change-timezone-modal'
import ChangePasswordProfileModal from 'containers/profile/change-password-profile-modal'
import { localizedTranslate } from 'assets/localization'
import { updateUserTimezone, matchCurrentPassword } from 'store/user/userActions'
import { fillTimezoneLabel } from 'shared/helpers/functional'

import 'less/profile.less'

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.isPMOrAdmin = isPMOrAdmin()
    this.isQSAdmin = isQSAdmin()
    this.state = {
      linksArray: [{
        display: 'Interviews',
        icon: 'im-ic-interview',
        path: '/interviews',
      }, {
        display: this.isPMOrAdmin ? 'All Moderator Calendar' : 'My Schedule',
        icon: this.isPMOrAdmin ? 'im-calendar-all-moderator' : 'im-calendar',
        path: '/moderator/schedule',
        className: this.isPMOrAdmin ? 'all-moderator-schedule' : '',
      }, {
        display: 'Profile',
        icon: 'im-ss-user',
        path: '/profile',
      }]
    }
  }

  componentDidMount() {
    if (this.isPMOrAdmin) {
      let linksArr = this.state.linksArray.slice()
      linksArr.splice(0, 0, {
        display: 'Projects',
        icon: 'im-ss-inboxes',
        path: '/projects',
      })
      linksArr.splice(3, 0, {
        display: 'Moderator Management',
        icon: 'im-user2',
        path: '/moderatorManagement/schedule',
        className: 'all-moderator-schedule',
      })
      this.isQSAdmin && linksArr.splice(4, 0, {
        display: 'User Management',
        path: '/userManagement',
        className: 'user-management',
      })
      this.setState({ linksArray: linksArr })
    }
  }

  render() {
    const timezoneLabel = timezone.get(this.props.userTimeZone)
    return (
      <div className="top-level-content-wrap">
        <Sidebar
          links={this.state.linksArray}
        />
        <div id="profile" className="top-level-content">
          <div className="topbar">
          </div>
          <div className="profile-container">
            <div className={`profile ${this.state.showUpdatePasswordForm ? 'password-toggled' : ''}`}>
              <div className="user-circle-wrap" />
              <div className="user-name">{`${Storage.getItem('firstName')} ${Storage.getItem('lastName')}`}</div>
              <div className='email'> {this.props.userEmail} </div>
              {this.props.userTimeZone !== "" && <div className='user-timezone'> {fillTimezoneLabel(this.props.userTimeZone)} {timezoneLabel} </div>}
              <div className="update-timezone-toggle">
                <i className="im-ss-clock" />
                <Button className="update-timezone-toggle-btn btn-primary"
                  onClick={() => this.props.openChangeTimzoneModal()
                  }
                >  Change Time Zone
                </Button>
              </div>
              <div className="update-password-toggle">
                <i className="im-key" />
                <Button className="update-password-toggle-btn btn-primary"
                  onClick={() => this.props.openChangePasswordModal()}>
                  Change Password
                </Button>
              </div>
              <div className='contact-us'> {this.props.t('contact.us')}
                <a href="https://healthcare.opinionsite.com/page/26" target="_blank" rel="noopener noreferrer"> {this.props.t('shg.email')} </a>
              </div>
            </div>
            <div className="privacy-policy">
              <a href="https://healthcare.opinionsite.com/page/26" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>
          </div>
        </div>
        {this.props.changeTimezoneModal.isOpen && <ChangeTimeZoneModal
          isOpen={this.props.changeTimezoneModal.isOpen}
          onClose={this.props.closeChangeTimzoneModal}
          isSubmitting={this.props.isSubmitting}
          t={this.props.t}
          userTimeZone={this.props.userTimeZone}
          updateUserTimezone={this.props.updateUserTimezone}

          userId={this.props.user.userId}
        />}
        {this.props.changePasswordModal.isOpen && <ChangePasswordProfileModal
          isOpen={this.props.changePasswordModal.isOpen}
          onClose={this.props.closeChangePasswordModal}
          isSubmitting={this.props.isSubmitting}
          t={this.props.t}
          userTimeZone={this.props.userTimeZone}
          matchCurrentPassword={this.props.matchCurrentPassword}
          isFetching={this.props.isFetching}
          user={this.props.user}
        />}
      </div>
    )
  }
}

const mapState = state => ({
  isFetching: state.user.isFetching,
  changeTimezoneModal: state.ui.changeTimezoneModal,
  changePasswordModal: state.ui.changePasswordModal,
  t: localizedTranslate('en', state.translations.en_us),
  userTimeZone: state.user.userInfo.timeZone,
  isSubmitting: state.user.isSubmitting,
  userEmail: state.user.email,
  user:state.user
})

const mapDispatch = {
  openChangeTimzoneModal: () => ({ type: 'OPEN_CHANGE_TIMEZONE_MODAL' }),
  closeChangeTimzoneModal: () => ({ type: 'CLOSE_CHANGE_TIMEZONE_MODAL' }),
  openChangePasswordModal: () => ({ type: 'OPEN_CHANGE_PASSWORD_MODAL' }),
  closeChangePasswordModal: () => ({ type: 'CLOSE_CHANGE_PASSWORD_MODAL' }),
  updateUserTimezone,
  matchCurrentPassword,
}

export default connect(mapState, mapDispatch)(Profile)
